// Which recipients of a sent agreement can have their email corrected.
//
// An agent mistyped a vendor's email when sending an authority; once the first
// vendor signed, "Edit details" vanished and the wrong address could not be
// fixed. The "Fix email & resend" action corrects a recipient who has NOT
// signed yet, leaving signed parties (and the document) untouched. This picks
// exactly those recipients the agent may edit:
//   - a signer/approver (people the agent is a recipient of, not viewers),
//   - whose signing order has not signed (matched via the sign request, which
//     the backend keeps in sync with the recipient's order), and
//   - not the agent's own pre-signed row.
export function unsignedEditableRecipients(envelope, meEmail = '') {
  if (!envelope) return [];
  const me = (meEmail || '').toLowerCase();
  const signedOrders = new Set(
    (envelope.sign_requests || [])
      .filter((sr) => sr.status === 'signed')
      .map((sr) => sr.order),
  );
  return (envelope.recipients || [])
    .filter((r) => r.role === 'signer' || r.role === 'approver')
    .filter((r) => !signedOrders.has(r.order))
    .filter((r) => (r.email || '').toLowerCase() !== me)
    .map((r) => ({ id: r.id, name: r.name || '', email: r.email || '', role: r.role, order: r.order || 1 }));
}
